import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css, ClassNames, } from '@emotion/react';
import { memo } from 'react';
import LazyLoad from 'react-lazyload';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { Button } from '../Button/index';
import { LAZY_LOAD_TOP_OFFSET } from './constants';
import { FavoriteIconButton, } from './FavoriteIconButton';
const baseStylesString = `
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  max-width: ${styleUtils.rem(190)};
`;
const imageContainerStyles = css `
  height: ${styleUtils.rem(155)};
  margin-bottom: ${theme.spacing.x3};
  position: relative;
  ${styleUtils.flexCenter}
  flex: 0 0 auto;
`;
const imageStyles = (wrapperClassName) => css `
  display: block;
  max-width: 100%;
  max-height: 100%;

  .${wrapperClassName}:hover & {
    opacity: 0.5;
  }
`;
// repeat class name to prevent global styles of the page from having priority
// over the expected style of the component
const shopNowButtonStyles = (wrapperClassName) => css `
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: none;
    visibility: hidden;
    text-decoration: none;
    color: ${theme.colors.gray100};
  }

  &&:hover {
    opacity: 1;
  }

  .${wrapperClassName}:hover && {
    visibility: initial;
  }
`;
// repeat class name to prevent global styles of the page from having priority
// over the expected style of the component
const productNameStyles = css `
  && {
    ${theme.typeStyles.bodySmallStyles}
    align-self: center;
    max-width: 100%;
    text-decoration: none;
    color: ${theme.colors.accent600};
    overflow-wrap: break-word;
  }

  &&:hover {
    color: ${theme.colors.accent600};
  }
`;
const productKindStyles = css `
  ${theme.typeStyles.bodyExtraSmallStyles}
  align-self: center;
  max-width: 100%;
  margin: 0;
`;
// repeat class name to prevent global styles of the page from having priority
// over the expected style of the component
const artistNameStyles = css `
  && {
    ${theme.typeStyles.bodyExtraSmallStyles}
    align-self: center;
    max-width: 100%;
    text-decoration: none;
    margin: 0 0 ${theme.spacing.base};
    color: ${theme.colors.gray700};
    overflow-wrap: break-word;
  }

  &&:hover {
    opacity: 0.8;
  }
`;
const defaultProps = {
    className: '',
    lazyloadImage: false,
    onFavoriteClick: () => { },
    productKind: undefined,
};
const ProductCellSecondary = ({ artistName, artistUrl, buyUrl, className = defaultProps.className, favorited, imageAlt, imageUrl, lazyloadImage, onFavoriteClick = defaultProps.onFavoriteClick, productKind, productName, }) => (_jsx(ClassNames, { children: ({ css: classNameGenerator, cx, }) => {
        const wrapperClassName = cx(classNameGenerator(baseStylesString), className);
        return (_jsxs("div", Object.assign({ className: wrapperClassName }, { children: [_jsxs("div", Object.assign({ css: imageContainerStyles }, { children: [lazyloadImage ?
                            (_jsx(LazyLoad, Object.assign({ offset: LAZY_LOAD_TOP_OFFSET, once: true }, { children: _jsx("img", { alt: imageAlt, css: imageStyles(wrapperClassName), src: imageUrl }) })))
                            : (_jsx("img", { alt: imageAlt, css: imageStyles(wrapperClassName), src: imageUrl })), _jsx("div", Object.assign({ css: shopNowButtonStyles(wrapperClassName) }, { children: _jsx(Button, { href: buyUrl, size: "small", text: "Shop Now", type: "primary" }) }))] })), _jsx("a", Object.assign({ css: productNameStyles, href: buyUrl }, { children: productName })), productKind && (_jsx("p", Object.assign({ css: productKindStyles }, { children: productKind }))), _jsx("a", Object.assign({ css: artistNameStyles, href: artistUrl }, { children: artistName })), _jsx(FavoriteIconButton, { css: css `
              flex: 0 0 auto;
            `, favorited: Boolean(favorited), onFavoriteClick: onFavoriteClick, size: "extraSmall" })] })));
    } }));
const MemoizedProductCellSecondary = memo(ProductCellSecondary);
export { MemoizedProductCellSecondary as ProductCellSecondary };
// MC-1068 Temporary hack for Storybook.
export default ProductCellSecondary;
